export function getRandomId() {
  // A simple algorithm to produce a randomly generated 6-char string
  return "_".concat(Math.random().toString(36).slice(2).substr(0, 6));
}